<section class="section_column_selector" (click)="sectionClick($event)">
  <button mat-raised-button color="primary" (click)="resetDefaultsColumns()" class="btn-reset">Reset columnas</button>
  <span>
    <mat-checkbox class="example-margin"
      [color]="'Primary'"
      [checked]="allComplete"
      [indeterminate]="someComplete()"
      (change)="setAll($event.checked)">
      {{columns_to_select.name}}
    </mat-checkbox>
  </span>
  <span class="example-list-section">
    <ul>
      @for (column of columns_to_select.columns; track column) {
        <li>
          <mat-checkbox [(ngModel)]="column.completed"
            (ngModelChange)="updateAllComplete()">
            {{column.name}}
          </mat-checkbox>
        </li>
      }
    </ul>
  </span>
</section>